/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monstertrialperiod1m2Inputs */



/**
* | output |
* | --- |
* | "month" |
*
* @param {Monstertrialperiod1m2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monstertrialperiod1m2 = /** @type {((inputs?: Monstertrialperiod1m2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monstertrialperiod1m2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("month")
	if (locale === "es") return /** @type {LocalizedString} */ ("mes")
	return /** @type {LocalizedString} */ ("месяц")
});
export { monstertrialperiod1m2 as "monsterTrialPeriod1m" }